import {Component, OnInit} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { AppConfigService } from '../../../../Services/app-config.service';
import { Title } from '@angular/platform-browser';
import { ResponseModel } from '../../../../DataModels/response-model';
import { DateFilterService } from '../../../../Services/dateFilter.service';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagerStateService } from '../../../../Services/pager-state.service';
import { NgbpaginationConfigService } from '../../../../Services/ngbpagination-config.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-bom-list',
  templateUrl: './bom-list.component.html',
  styleUrls: ['./bom-list.component.css'],
  standalone: false
})
export class BomListComponent extends ListPageBase implements OnInit {
  constructor(
    private table: DataService,
    private toastr: BsToastService,
    private titleService: Title,
    private dateFilter: DateFilterService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  vm: any = [];
  BOMCount = 0;
  isLoaded = false;



  ngOnInit() {
    this.restorePagerState();
    this.vm.list = [];
    this.titleService.setTitle($localize`:Bills of Materials List @@billsofMaterialsList:Bills of Materials List`);
    this.getData();
  }

  getData() {
    let paramString =
      '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString +=
      '&fromDate=' +
      (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString +=
      '&toDate=' +
      (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.table.getApiListData('BillOfMaterials', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.BOMCount = result.totalRecords;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        console.log(error + ' - ' + $localize`:Error loading Bill of Materials Data @@errorloadingBillofMaterialsData:Error loading Bill of Materials Data`);
      },
      () => {}
    );
  }

  onNavigate(aID: string) {
    this.router.navigate(['inventory/bill-of-materials/bom-form', { id: aID }]).then();
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    let paramString =
      '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString +=
      '&fromDate=' +
      (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString +=
      '&toDate=' +
      (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.table.getApiListData('BillOfMaterials', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        console.log(error + ' - ' + $localize`:Error loading Bill of Materials Data @@errorloadingBillofMaterialsData:Error loading Bill of Materials Data`);
      },
      () => {}
    );
  }

  serverSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }
}
